/**
 * @generated SignedSource<<9aa40f129beadb9c69c61531c279003a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tradePointId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "tradePointId",
        "variableName": "tradePointId"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "acceptNominatedTrade",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptNominatedTradeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptNominatedTradeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "185f312f101072f461ebe926d1500894",
    "id": null,
    "metadata": {},
    "name": "AcceptNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptNominatedTradeMutation(\n  $id: ID!\n  $tradePointId: String!\n) {\n  acceptNominatedTrade(id: $id, tradePointId: $tradePointId) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "3475115d5488c4dffc35371270d790ee";

module.exports = node;
